import { Impression } from '../../constants-types/Enums';
import { ReferencePatternType } from '../ReferencePatternType.model';
import { JobPipelineHealth } from './JobPipelineHealth.model';
import { RefProfileReportInfo } from './JobReportInfo.model';

export type ActiveJobEntryAssociatedPerson = {
    id: string;
    firstName: string;
    lastName: string;
    lastCompleted: Date;
    referencePattern: ReferencePatternType;
    overallFitScore: number;
    personImpression: Impression;
    hasPendingBehavioral: boolean;
    hasPendingCognitive: boolean;
};

export type ActiveJobEntryJobAssessment = {
    refProfileId: string;
    completedDate: Date;
};

export class ActiveJobEntryJob {
    id: string;
    title: string;
    createdDate: Date;

    jobPipeline: JobPipelineHealth;
    matchingProfiles: RefProfileReportInfo[];

    constructor(options: Partial<ActiveJobEntryJob>) {
        Object.assign(this, options);
    }

    get hasTarget(): boolean {
        return this.matchingProfiles.length > 0;
    }
}

export type ActiveJobEntry = {
    job: ActiveJobEntryJob;
    associatedPeople: ActiveJobEntryAssociatedPerson[];
};
